import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getInvestorApiUrl } from "../../utils/config"; // Assuming this function provides the base URL.
import { ApiRequestParams, handleFetchApi } from "../../utils/api";

interface initialState {
  signedAgreement: any;
  loading: boolean;
  error: any;
}
const initialState: initialState = {
  signedAgreement: {},
  loading: false,
  error: null,
};

// Thunk to get favorite properties
export const getSignedAgreement = createAsyncThunk(
  "signedAgreement/getSignedAgreement",
  async (email, { rejectWithValue }) => {
    try {
      const params: ApiRequestParams = {
        baseUrl: getInvestorApiUrl(),
        endpoint: `registration/investors/signedbiddingaggrement?email=${email}`,
      };
      const response = await handleFetchApi(params);

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice to manage favorite properties
const signedAgreementSlice = createSlice({
  name: "favoriteproperty",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSignedAgreement.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSignedAgreement.fulfilled, (state, action) => {
        state.loading = false;
        state.signedAgreement = action.payload;
      })
      .addCase(getSignedAgreement.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default signedAgreementSlice.reducer;
